import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
  }
}

export const PIXEL_ID = '1688179945683486'

export function initMetaPixel() {
  if (typeof window === 'undefined') return

  // Avoid double initialization
  if (window.fbq) return // Meta Pixel base code - optimized
  ;(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.defer = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackEvent(eventName: string, data?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, data)
  }
}

export function useMetaPixelViewTracking(
  elementId: string,
  eventData?: Record<string, any>,
) {
  useEffect(() => {
    const element = document.getElementById(elementId)
    if (!element) return

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            trackEvent('ViewContent', {
              content_name: elementId,
              ...eventData,
            })
            observer.disconnect()
          }
        })
      },
      { threshold: 0.5, rootMargin: '50px' },
    )

    observer.observe(element)

    return () => observer.disconnect()
  }, [elementId, eventData])
}
